export const usernameValidation = (value: string) => {
  const regex = /^[A-Za-z]{3}\d{5,6}$/g;
  if (value.length >= 8) {
    if (regex.test(value)) {
      return true;
    }
    return false;
  }
  return null;
};

export const VALIDATOR_PATTERN = {
  NAME: /^([A-Za-zÁÉÍÓÚñáéíóúÑ\-]{0}?[A-Za-zÁÉÍÓÚñáéíóúÑ\-\s\']+$)/, // eslint-disable-line
  SURNAME:
    /^([A-Za-zÁÉÍÓÚñáéíóúÑ\-]{0}?[A-Za-zÁÉÍÓÚñáéíóúÑ\-\']+[\s])+([A-Za-zÁ-ÉÍÓÚñáéíóúÑ\-]{0}?[A-Za-zÁÉÍÓÚñáéíóúÑ\-\'])+[\s]?([A-Za-zÁÉÍÓÚñáéíóúÑ\-]{0}?[A-Za-zÁÉÍÓÚñáéíóúÑ\-\'])?$/, // eslint-disable-line
  PHONE: /^(\+34|0034|34)?[ .-]*(6|7)[ .-]*([0-9][ .-]*){8}$/i,
  EMAIL: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
  DNI: /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/i,
  NIE: /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/i,
  DNI_CHARS: 'TRWAGMYFPDXBNJZSQVHLCKE',
  FORBIDDEN_SURNAME_LIST: [
    'DE',
    'DEL',
    'LA',
    'LOS',
    'LAS',
    'Y',
    'SAN',
    'SANTI',
    'SANTO',
    'SANTA',
    'MA',
    'VON',
    'MC',
    'MAC',
  ],
  POSTAL_CODE: /^(?:0?[1-9]|[1-4]\d|5[0-2])\d{3}$/i,
  ONLY_NUMBERS: /^[0-9]*$/i,
  DECIMAL_AMOUNT: /^[0-9]+(\.[0-9]+)?$/,
};
export const separateSurname = (surname: string) => {
  const surnameArray = surname.match(/([^\s]+)/g);
  let surname1;
  let surname2;
  let error = false;
  const originalSurnameArray = JSON.parse(JSON.stringify(surnameArray));
  for (let i = 0; i < originalSurnameArray.length; i += 1) {
    if (!surname1) {
      if (!VALIDATOR_PATTERN.FORBIDDEN_SURNAME_LIST.includes(originalSurnameArray[i].toUpperCase())
        && originalSurnameArray[i].length >= 2) {
        surname1 = surnameArray?.splice(0, i + 1);
        surname1 = surname1?.join(' ');
      } else {
        error = true;
      }
    } else {
      surname2 = surnameArray;
      surname2 = surname2?.join(' ');
      error = !(!VALIDATOR_PATTERN.FORBIDDEN_SURNAME_LIST.includes(originalSurnameArray[i].toUpperCase())
        && originalSurnameArray[i].length >= 2);
    }
  }
  return { surname1, surname2, error };
};